(function() {

    var $scope = $('.form-list');

    if ($scope.length === 0) {
        return;
    }

    var $master = $scope.find('thead input[type=checkbox]');
    var $checkboxes = $scope.find('tbody input[type=checkbox]');
    var $actions = $scope.find('.batch-operation select, .batch-operation button');

    var $table = $scope.find('table');

    var counter = 0;

    function selectAll() {
        $checkboxes.each(function() {
            if (!this.checked) {
                counter++;
                this.checked = true;
            }
        });
    }

    function deselectAll() {
        $checkboxes.each(function() {
            if (this.checked) {
                counter--;
                this.checked = false;
            }
        });
    }

    function refresh() {
        $actions.attr('disabled', !counter);
        if ($checkboxes.length) {
            $master.attr('checked', !!(counter === $checkboxes.length));
        }
    }

    $table.on('click', 'input[type=checkbox]', function(event) {
        var $checkbox = $(this);
        var checkbox = this;

        if (typeof $checkbox.data('master') === 'undefined') {
            checkbox.checked ? counter++ : counter--;
        } else {
            if (checkbox.checked) {
                selectAll();
            } else {
                deselectAll();
            }
        }

        refresh();
    });

    refresh();

})();